// NOTE This file is auto-generated by generated-site-data.mjs

export default [
  {
    id: "errors",
    name: "Error Tracking",
    core: true,
    description:
      "Track exceptions, get error alerts, debug and fix bugs with ease.",
    icon: "bug",
    styles: {
      text: "text-orange-500",
      box: "c_h-icon-box--orange",
    },
    link: "https://www.appsignal.com/tour/errors/",
    featureTabs: {
      name: "Errors",
      bullets: [
        "Detailed error reports",
        "Real-time error alerts",
        "Send to your issue tracker",
        "Tag errors with custom attributes",
        "Filter & find errors",
      ],
      gradient: "bg-gradient-to-b from-orange-400 to-orange-600/25",
      image: {
        src: "/assets/pages/tour/errors/incident-detail.jpg",
        srcMobile: "/assets/pages/tour/errors/incident-detail-mobile.jpg",
        alt: "Error tracking screenshot of AppSignal APM with an error sample in view.",
        color: "orange",
      },
    },
  },
  {
    id: "performance",
    name: "Performance Monitoring",
    core: true,
    description:
      "Monitor the performance of your slowest actions down to the nanosecond.",
    icon: "rabbit-fast",
    styles: {
      text: "text-green-500",
      box: "c_h-icon-box--green",
    },
    link: "https://www.appsignal.com/tour/performance",
    featureTabs: {
      name: "Performance",
      bullets: [
        "Alerts for slow requests",
        "Duration breakdown",
        "Detailed tracing timeline",
        "Find and fix slow queries",
        "90th percentile breakdown",
      ],
      gradient: "bg-gradient-to-b from-green-400 to-green-600/25",
      image: {
        src: "/assets/pages/tour/performance/performance-incident.jpg",
        srcMobile:
          "/assets/pages/tour/performance/performance-incident-mobile.jpg",
        alt: "Performance monitoring screenshot of AppSignal APM with a slow request in view.",
        color: "green",
      },
    },
  },
  {
    id: "hosts",
    name: "Host Monitoring",
    core: true,
    description:
      "Monitoring for your servers: keep an eye on CPU, Disk, Network & more.",
    icon: "server",
    styles: {
      text: "text-teal-500",
      box: "c_h-icon-box--teal",
    },
    link: "https://www.appsignal.com/tour/hosts",
    featureTabs: {
      name: "Host",
      bullets: [
        "CPU usage",
        "Disk I/O and usage",
        "Load average",
        "Memory & Network usage",
        "Kubernetes metrics",
      ],
      gradient: "bg-gradient-to-b from-teal-400 to-teal-600/25",
      image: {
        src: "/assets/pages/tour/hosts/latest-host-metrics.jpg",
        srcMobile: "/assets/pages/tour/hosts/latest-host-metrics-mobile.jpg",
        alt: "Server monitoring screenshot of AppSignal APM with a list of hosts and their metrics.",
        color: "teal",
      },
    },
  },
  {
    id: "anomalies",
    name: "Anomaly Detection",
    core: true,
    description:
      "Avoid surprises and set triggers for anomalies on any metric you'd like.",
    icon: "siren-on",
    styles: {
      text: "text-red-500",
      box: "c_h-icon-box--red",
    },
    link: "https://www.appsignal.com/tour/anomaly-detection",
    featureTabs: {
      name: "Anomalies",
      bullets: [
        "Set alerts on any metric",
        "Pre-configured for key alerts",
        "Reduce noise with smart delays",
        "Send via Slack, email, and more",
      ],
      gradient: "bg-gradient-to-b from-red-400 to-red-600/25",
      image: {
        src: "/assets/pages/tour/anomaly-detection/alert-list.jpg",
        srcMobile: "/assets/pages/tour/anomaly-detection/alert-list-mobile.jpg",
        alt: "Screenshot of anomalies feature of AppSignal APM",
        color: "red",
      },
    },
  },
  {
    id: "uptime",
    name: "Uptime Monitoring",
    core: true,
    description: "Get alerted in real-time when your application is down.",
    icon: "traffic-light",
    styles: {
      text: "text-yellow-500",
      box: "c_h-icon-box--yellow",
    },
    link: "https://www.appsignal.com/tour/uptime-monitoring",
    featureTabs: {
      name: "Uptime",
      bullets: [
        "Monitor uptime from around the globe",
        "Ping your site every 30 seconds",
        "Receive downtime notifications",
        "Free public status page",
      ],
      gradient: "bg-gradient-to-b from-yellow-400 to-yellow-600/25",
      image: {
        src: "/assets/pages/tour/uptime-monitoring/uptime-monitors.jpg",
        srcMobile:
          "/assets/pages/tour/uptime-monitoring/uptime-monitors-mobile.jpg",
        alt: "Screenshot of the uptime monitoring feature of AppSignal APM",
        color: "yellow",
      },
    },
  },
  {
    id: "metric-dashboards",
    name: "Metric Dashboards",
    core: true,
    description:
      "Collect metrics from your code and chart them on interactive dashboards.",
    icon: "gauge-high",
    styles: {
      text: "text-purple-500",
      box: "c_h-icon-box--purple",
    },
    link: "https://www.appsignal.com/tour/metrics",
    featureTabs: {
      name: "Metrics",
      bullets: [
        "Dozens of auto-generated dashboards",
        "Build custom dashboards in minutes",
        "Export and share charts",
        "View in fullscreen mode",
        "Easily compare timeframes",
      ],
      gradient: "bg-gradient-to-b from-purple-400 to-purple-600/25",
      image: {
        src: "/assets/pages/tour/metrics/dashboard-overview.jpg",
        srcMobile: "/assets/pages/tour/metrics/dashboard-overview-mobile.jpg",
        alt: "Monitoring dashboard screenshot of AppSignal APM with a series of graphs in view.",
        color: "purple",
      },
    },
  },
  {
    id: "workflow",
    name: "Workflow",
    core: false,
    description: "AppSignal keeps your team focused on writing great code.",
    icon: "users",
    styles: {
      text: "text-blue-500",
      box: "c_h-icon-box--blue",
    },
    link: "https://www.appsignal.com/tour/workflow",
  },
  {
    id: "logging",
    name: "Log Management",
    core: true,
    description: "Collect and manage logs in an easy-to-use interface.",
    icon: "line-columns",
    styles: {
      text: "text-hot-pink-500",
      box: "c_h-icon-box--hot-pink",
    },
    link: "https://www.appsignal.com/tour/log-management",
    featureTabs: {
      name: "Logging",
      bullets: [
        "Centralized log management",
        "Simple search and filtering",
        "Link to error and performance issues",
        "Log custom attributes",
      ],
      gradient: "bg-gradient-to-b from-hot-pink to-pink-300",
      image: {
        src: "/assets/pages/tour/log-management/log-management.jpg",
        srcMobile:
          "/assets/pages/tour/log-management/log-management-mobile.jpg",
        alt: "Screenshot of the logging feature of AppSignal APM",
        color: "pink",
      },
    },
  },
  {
    id: "automated-dashboards",
    name: "Automated Dashboards",
    core: false,
    description: "Visualize your application performance metrics.",
    icon: "gauge-high",
    styles: {
      text: "text-purple-500",
      box: "c_h-icon-box--purple",
    },
    link: "https://www.appsignal.com/tour/automated-dashboards",
  },
  {
    id: "check-ins",
    name: "Check-ins",
    core: true,
    description: "Monitor your application's background jobs and processes.",
    icon: "check-square",
    styles: {
      text: "text-blue-500",
      box: "c_h-icon-box--blue",
    },
    link: "https://www.appsignal.com/tour/check-ins",
    featureTabs: {
      name: "Check-ins",
      bullets: [
        "Monitor scheduled jobs",
        "Track continuous processes",
        "Alerts for missed check-ins",
        "Detailed job performance insights",
      ],
      gradient: "bg-gradient-to-b from-blue-400 to-blue-600/25",
      image: {
        src: "/assets/pages/tour/check-in/daily-check.jpg",
        srcMobile: "/assets/pages/tour/check-in/daily-check-mobile.jpg",
        alt: "Screenshot of the check-ins feature of AppSignal APM",
        color: "blue",
      },
    },
  },
  {
    id: "time-detective",
    name: "Time Detective",
    core: false,
    description: "Monitor your application's background jobs and processes.",
    icon: "user-secret",
    styles: {
      text: "text-azure-500",
      box: "c_h-icon-box--azure",
    },
    link: "https://www.appsignal.com/tour/time-detective",
  },
];
